/**
 * 客户物料指定供应商 - 枚举定义
 * @module types/customer-material-supplier
 */

/**
 * 指定类型枚举
 */
export enum DesignationType {
  /** 推荐 - 优先选择，非强制 */
  RECOMMENDED = 1,
  /** 指定 - 客户指定，采购时提示 */
  DESIGNATED = 2,
  /** 独家 - 独家供应，必须从此供应商采购 */
  EXCLUSIVE = 3,
}

/**
 * 状态枚举
 */
export enum CustomerMaterialSupplierStatus {
  /** 禁用 */
  DISABLED = 0,
  /** 启用 */
  ENABLED = 1,
}
